import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
  Stack,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import AvatarRem from "../AvatarRem";

interface HodDialogsProps {
  isDialogOpen: boolean;
  setDialogOpen: (open: boolean) => void;
  loadingUsers: boolean;
  groupUsers: {
    id: number;
    name: string;
    firstname: string;
    lastname: string;
    picture: string;
  }[];
  handleUserSelect: (user: {
    id: number;
    firstname: string;
    lastname: string;
  }) => void;
  isConfirmDialogOpen: boolean;
  setConfirmDialogOpen: (open: boolean) => void;
  selectedUser: { id: number; name: string } | null;
  handleConfirmAssign: () => void;
}

const HodDialogs: React.FC<HodDialogsProps> = ({
  isDialogOpen,
  setDialogOpen,
  loadingUsers,
  groupUsers,
  handleUserSelect,
  isConfirmDialogOpen,
  setConfirmDialogOpen,
  selectedUser,
  handleConfirmAssign,
}) => {
  const translations = useTranslations();

  return (
    <React.Fragment>
      {/* Dialog per la selezione dell'utente */}
      <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>{getTranslation(translations, "generic.assign_task_to_user")}</span>
          <IconButton
            onClick={() => setDialogOpen(false)}
            sx={{ padding: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {loadingUsers ? (
            <Stack>
              <CircularProgress />
            </Stack>
          ) : (
            <List>
              {groupUsers.map((user) => (
                <ListItemButton
                  key={user?.id}
                  onClick={() => handleUserSelect(user)}
                  id="hod-assigning-user"
                >
                  <AvatarRem
                    icon={user?.picture || ""}
                    sx={{ marginRight: "5px" }}
                  />
                  <ListItemText
                    primary={`${user.firstname} ${user.lastname}`}
                  />
                </ListItemButton>
              ))}
            </List>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog di conferma */}
      <Dialog
        open={isConfirmDialogOpen}
        onClose={() => setConfirmDialogOpen(false)}
      >
        <DialogTitle>
          {getTranslation(translations, "generic.confirm_task_assignment")}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {getTranslation(translations, "generic.assigning_task_to_user")}{" "}
            {selectedUser?.name}
          </Typography>
        </DialogContent>
        <DialogActions>
          <IconButton onClick={() => setConfirmDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
          <IconButton
            id="hod-confirms-user"
            onClick={handleConfirmAssign}
            color="primary"
          >
            <CheckIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default HodDialogs;
